import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Agent } from "@/model";
import agentRepository from "@/repository/agentRepository";
import { agentQueryKeys } from "./keys";


export const useDeactivateAgent = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<Agent, AxiosError>({
        mutationKey: ["agent", "deactivate"],
        mutationFn: async () => {
            try {
                const { data } = await agentRepository.deactivate(agentId);
                return data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: agentQueryKeys.pageAll(),
                exact: false
            });
            await queryClient.invalidateQueries({
                queryKey: agentQueryKeys.recent(),
                exact: false
            });
            // prevent fallback to error page before navigation
            await queryClient.invalidateQueries({
                queryKey: agentQueryKeys.read(agentId),
                exact: false
            });
        }
    });
};
